import React from 'react';
import SectionFactory from '../sections/SectionFactory';

const ChooserModule = ({ data }) => {
    return (
        <>
            {data.sections.map((section, index) => {
                return (
                    <SectionFactory
                        section={section}
                        key={`${section.type}__${index}`}
                    />
                )
            })}
        </>
    );
}

export default ChooserModule;